import Vue from "vue";
import Router from "vue-router";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style

import Login from "./views/Login.vue";
import NotFound from "./views/404.vue";
import Layout from "./views/Layout.vue"; //layout
import store from "./store";

const routes = [
  // 净水设备监控首页
  {
    path: "/",
    component: Layout,
    name: "首页",
    iconCls: "el-icon-s-home",
  },

  {
    path: "/Login",
    component: Login,
    name: "云术",
    hidden: true,
  },
  {
    path: "/404",
    component: NotFound,
    name: "Error",
    hidden: true,
  },
  // 捕获所有未匹配路由，重定向到404
  {
    path: "*",
    redirect: "/404",
    hidden: true
  }
];

const router = new Router({ routes, mode: "hash" });

// 添加导航守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  const title = to && to.name;
  if (title) {
    document.title = title;
  }

  NProgress.start();

  // 登录页面直接放行
  if (to.path === "/Login") {
    next();
    NProgress.done();
    return;
  }

  if (!store.getters.isDeviceAuthenticated) {
    // 未登录，跳转到登录页
    next({ path: "/Login" });
    NProgress.done();
    return;
  }

  // 已登录，继续访问
  next();
});

router.afterEach(() => {
  NProgress.done(); // finish progress bar
});
/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  // console.log(location)
  return routerPush.call(this, location).catch((error) => error);
};
Vue.use(Router);
export { router };
